var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 38,
    viewBox: "0 0 50 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_526_141419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.1381 2.04688H15.9766L16.0659 2.26955L18.2448 7.63172L44.8361 7.653C44.8361 7.653 45.7995 7.70678 46.3347 7.82629L46.2792 7.80665V3.17489C46.2792 2.55111 45.7683 2.04688 45.1381 2.04688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8362 7.6526L18.2448 7.63133L16.0659 2.26915L15.1446 0H2.41708C1.08107 0 0 1.07048 0 2.39288V35.1074C0 36.4281 1.08107 37.5 2.41708 37.5H47.5815C48.9173 37.5 50 36.4281 50 35.1074V12.5978C50 10.3252 48.4444 8.41294 46.3347 7.82589C45.7996 7.70638 44.8362 7.6526 44.8362 7.6526ZM49.4634 32.1549V33.9403H0.540412V32.1549H49.4634Z",
    fill: "#6474E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 31.9629H0V33.9763H50V31.9629Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_526_141419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 37.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.173d0fed8de273bcccaed4a9cfb836ce.svg";
export { ForwardRef as ReactComponent };